import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { Spinner, Col, Row, Container } from 'reactstrap';
import { getSelectedUserCourse } from '../../store/userCourses/selectors';
import { IUserCourse } from '../../store/interface';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import DetailForm from './detailForm';
import BlobUtil from '../../utils/blobUtil'

import { listRequest as listRequestAction,
    createRequest as createRequestAction,
    updateRequest as updateRequestAction,
    deleteRequest as deleteRequestAction,
    selectData as selectDataAction, 
    selectedData as selectedAction,
    selectedClear as selectedClearAction
} from '../../store/userCourses/actions';

import UserTopNav from '../../components/userTopNav';

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    ui : any
}

interface IState {
    isNew: boolean
    modalOverwriteWarning: boolean
    loaded : boolean
    RegisterFaceImgList : any []
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction
    createRequest : typeof createRequestAction
    updateRequest : typeof updateRequestAction
    deleteRequest : typeof deleteRequestAction
    selectData : typeof selectDataAction
    selectedData : typeof selectedAction
    selectedClear : typeof selectedClearAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class UserCourseDetailPage extends React.Component<AllProps, IState> {
    blobUtil: BlobUtil;

    constructor(props: AllProps) {
        super(props);
        this.state = {
            modalOverwriteWarning : false,
            isNew : false,
            loaded : false, 
            RegisterFaceImgList : []
        };
        this.blobUtil = new BlobUtil();
        this.readData = this.readData.bind(this);
        this.createOrUpdateData = this.createOrUpdateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.handleOverwriteWarning = this.handleOverwriteWarning.bind(this);
        this.getPicPath = this.getPicPath.bind(this);
        this.getImgURL = this.getImgURL.bind(this);
    }

    public componentDidMount() {
        let id = this.props.route.match.params.id; // User Id
        let userCourseId = this.props.route.match.params.userCourseId; // User Course Id Id
        if (userCourseId.toUpperCase() === "NEW"){
            //this.setState({isNew: true, newCourseId : this.generateCourseId(6)});
        }else{
            this.props.selectData(userCourseId);
        }
    }
    public componentWillUnmount() {
        this.props.selectedClear();  
    } 

    readData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.ui.selected;
        searchParams["period"] = Number(parsed.pk);
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listRequest(searchParams);
    }

    componentDidUpdate(prevProps: AllProps) {
        //console.log("componentDidUpdate : " + this.props.ui.selected);
        // Load data if direct access from link
        if (prevProps.ui.selected === undefined && this.props.ui.selected != undefined && this.props.data === undefined){
            this.readData();
        }

        // Load data to state for chanages
        if (this.props.ui.processState !== 3 && this.props.data !== undefined && !this.state.loaded){
                this.setState({ loaded : true}, () => {
                    this.props.selectedData();
    
                    this.getImgURL().then(imgList=> {
                        this.setState({ RegisterFaceImgList : imgList});
                        console.log(imgList);
                    })
                })
        }
        // Show notification
        if ((prevProps.data?._etag != this.props.data?._etag) || 
            (prevProps.ui.processState != this.props.ui.processState) ){
            let notification = { show : false, title:"", type: "", message : "" };

            if (this.props.ui.processState === 1){ // Create/Update success
                if (this.state.isNew){ // Added successfully
                    this.setState({isNew: false});
                    this.props.route.history.push('/users/' + this.props.ui.selected + "?pk=" + this.props.data.period);
                }
                notification.show = true;
                notification.type = "success";
                notification.message = "Save successfully";
                
            } else if (this.props.ui.processState === 2){ // Create/Update failed
                if (this.props.ui.isConflict){
                    this.setState({ modalOverwriteWarning : true});
                } else {
                    this.setState({ modalOverwriteWarning : false});

                    notification.show = true;
                    notification.type = "danger";
                    notification.message =  "Process failed. Error : \n" + this.props.ui.errors;
                }
            } else if (this.props.ui.processState === 3){ // Delete success
                // Show custom dialaog box
            } else if (this.props.ui.processState === 4){ // Delete failed
                notification.show = true;
                notification.type = "danger";
                notification.message =  "Delete failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show){
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                }); 
            }
        }
    }
    
   
    createOrUpdateData = async (formData:any) => {
        //console.log("createOrUpdate:" + JSON.stringify(data));
        //console.log("createOrUpdate:" + overwrite);

        if (this.state.isNew){
            // const orgProfile : OrganiserProfile = {
            //     organiserId : "",         
            //     userId : "",             
            //     name : "",        
            //     profile : "",     
            //     profileImgURL : "",
            //     companyName : "",
            //     companyProfile : "",
            //     companyProfileImgURL : ""
            // }
            // const cpdPoints : CPDPoints = {
            //     profession : "",         // Profession Name
            //     points : 0,             // CPD Hour/Points
            //     cpdRefNo : ""           // CPD Reference Number
            // }

            // const trainer: TrainerProfile = {
            //     name : "",
            //     profile : "",
            //     profileImgURL : ""
            // }
            // const conc : Concentration = {
            //     id : 1,
            //     duration : [0],
            //     AnswerSpot : 0
            // }
            // const n:Course ={
            //     id : "",                                        // Unique identifier (Backend)
            //     courseId : formData.courseId,                   // Course ID internal use
            //     referenceNumber: formData.referenceNumber,      // Course Internal Reference Number (Modifiable by admin, e.g. Certification serial number using this, admin can change every year / or define a format for it)
            //     type : "Course",                                // "Course"
            //     version: 1,                                     // Schema version number
            //     professionList: [],                             // Profession list
            //     countryList: [],                                // Course country lits
            //     languages: [],                                  // Course languages
            //     period: new Date().getFullYear(),               // Partition key, year of course
            //     courseStatus : "",                              // Course Status, temporary not in use, based on expiry date
            //     title: formData.title,                          // Course Title
            //     titleLowercase : formData.title.toLowerCase(),  // Title lowercase for sorting purpose
            //     shortDesc : "",                                 // Short description
            //     longDesc : "",                                  // Long description
            //     objective : "",                                 // Course objective
            //     programOutline : "",                            // Course outline
            //     qualification : "",                             // Qualificaiton
            //     requirement : "",                               // Requirements
            //     termsAndConditions : "",                        // Terms and conditons
            //     agenda : "",                                    // Course Agenda
            //     methodology : "",                               // Course Methodology
            //     publishedDT : new Date(),                       // Publish Date
            //     expiryDT : new Date(),                          // Expiry Date
            //     videoURL : "",                                  // Video URL (MP4)
            //     videoThumbnailURL : "",                         // Video Image URL (Thumbnail)
            //     uploadDT : new Date(),                          // Upload Date Time
            //     cpdPoints : [cpdPoints],                                // Array of CPDPoints
            //     duration : 0,                                   // Course duration
            //     normalPrice : 0,                                // Course Normal Price
            //     memberPrice: 0,                                 // Course Member Price
            //     discountPrice :0,                               // Course Discounted Price
            //     slidesFileURL : "",                             // Slides File URL
            //     courseShelfLifeDays : 0,                        // Life time course display on market place
            //     userShelfLifeDays : 0,                          // Life time user can playback
            //     organiser : orgProfile,                         // Organizer Profile
            //     trainerFAQFileURL : "",                         // Trainer FAQ
            //     trainerProfile : [trainer],                     // Trainer Profile
            //     certificateId : "",                             // Certificate Template ID to use
            //     concentrationId : "",                           // Concentration Template ID to use
            //     concentrationDurationSettingsJSON : [conc],     // Concentration settings
            //     createdDT : new Date(),                         // Course created on
            //     createdBy : "",                                 // Course created by
            //     lastEdited : new Date(),                        // Course last edited time
            //     lastEditBy : "",                                // Course last edited by who
            //     searchKeywords : ""                             // List of keywords for search
            // };

            //this.props.createRequest(n);
        } else {
            let overwriteFlag = formData.Overwrite === "true"? true:false;

            // this.props.updateRequest({
            //     id : this.props.ui.selected,
            //     period : this.props.data.period,
            //     courseId : this.props.data.courseId,
            //     title : formData.title,
            //     titleLowercase : formData.title.toLowerCase(),
            //     referenceNumber : formData.referenceNumber,
            //     overwrite : overwriteFlag,
            //     _etag : this.props.data._etag,
            // });

            if (overwriteFlag === true){
                this.handleOverwriteWarning(); // Trigger close warning modal dialog
            }
        }
    }

    deleteData = async (doc:IUserCourse) => {
        this.props.deleteRequest(doc);
    }
    
    handleOverwriteWarning(){
        this.setState({modalOverwriteWarning : !this.state.modalOverwriteWarning});
    }
    
    getImgURL = async () => {
        console.log("Call Get face imagess");
        if (this.props.data?.faceImageList){
            return Promise.all(
                this.props.data?.faceImageList.map((fileName: string) => { 
                    console.log(fileName);
                    return this.getPicPath(fileName) })
            );
        }else{
            return [];
        }
    }
    async getPicPath(fileName: string) {
        let imgUrl = "";
        imgUrl = await this.blobUtil.GetBlob(this.props.route.match.params.id, fileName);
        return imgUrl;
    }

    public render() {
        return (
            <Container>
                {this.props.ui.loading ? 
                    (
                        <div>Loading data&nbsp;<Spinner color="warning">Loading</Spinner></div>
                    )
                    :
                    (
                        <React.Fragment>
                            <UserTopNav activeTab = "Courses" selectedUserId ={this.props.data?.oId} />

                            <DetailForm 
                                props = {this.props} 
                                read = {this.readData}
                                save = {this.createOrUpdateData}
                                remove = {this.deleteData}
                                overwriteWarningFlag = {this.state.modalOverwriteWarning}
                                overwriteHandleWarning = {this.handleOverwriteWarning}
                                isNew = {this.state.isNew}
                                //newCourseId =  {this.state.newCourseId}
                            />
                            <Row>
                                {
                                    this.props.data?.faceImageList ?? [].length > 0 ? (
                                        <Col>
                                            {
                                                this.state.RegisterFaceImgList.map(
                                                    (fileName: string) => {
                                                        return <a href={fileName} target="_blank">
                                                                <img src = {fileName} width={192} />
                                                            </a>
                                                    }
                                                )
                                            }
                                        </Col>
                                    )  : (
                                        <span>No face image captured</span>
                                    )                                 
                                }
                                </Row>
                        </React.Fragment>
                    )
                }
                
            </Container>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.userCourse.ui,
    data: getSelectedUserCourse(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction,
    createRequest : createRequestAction,
    updateRequest : updateRequestAction,
    deleteRequest : deleteRequestAction,
    selectData : selectDataAction,
    selectedData : selectedAction,
    selectedClear : selectedClearAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserCourseDetailPage)
